import { SelectedContainersState } from "features/users/types";
import SessionsSelect from "ui/Form/Select/SessionsSelect";
import { TrashCanIcon } from "ui/Icons";
import { generateContainers } from "utils/form/sessions-form";

type SessionsProps = {
  containersAmount: number;
  disabled?: boolean;
  selectedContainers: SelectedContainersState;
  setSelectedContainers: React.Dispatch<
    React.SetStateAction<SelectedContainersState>
  >;
};

export const SessionsForm = ({
  containersAmount,
  disabled,
  selectedContainers,
  setSelectedContainers,
}: SessionsProps) => {
  const options = generateContainers(containersAmount);

  const handleSelectChange = (
    sessionKey: "session1" | "session2",
    selectKey: string,
    selectedValue: string | null,
  ) => {
    setSelectedContainers((prev) => ({
      ...prev,
      [sessionKey]: {
        ...prev[sessionKey],
        [selectKey]: selectedValue,
      },
    }));
  };

  const resetSelectValue = (
    sessionKey: "session1" | "session2",
    selectKey: string,
  ) => {
    setSelectedContainers((prev) => ({
      ...prev,
      [sessionKey]: {
        ...prev[sessionKey],
        [selectKey]: null,
      },
    }));
  };

  const getFilteredOptions = (
    currentSessionKey: "session1" | "session2",
    currentSelectKey: string,
  ) => {
    const allSelectedValues = Object.values(
      selectedContainers[currentSessionKey],
    ).filter(Boolean);
    const currentValue =
      selectedContainers[currentSessionKey][currentSelectKey];

    return options.filter(
      (option) =>
        option.value === currentValue ||
        !allSelectedValues.includes(option.value),
    );
  };

  const renderSession = (
    sessionKey: "session1" | "session2",
    sessionNumber: number,
  ) => (
    <div className="border rounded-lg px-6 py-6">
      <p className="mb-6 text-lg font-normal">{`Sesión ${sessionNumber}`}</p>
      {Array.from({ length: Math.min(containersAmount, 100) }, (_, index) => {
        const selectKey = `select-${index}`;
        const inputName = `session-${sessionNumber}-container-${index + 1}`;

        return (
          <div
            key={`${sessionKey}-${selectKey}`}
            className="flex items-center gap-4 mb-4"
          >
            <div className="flex-grow">
              <SessionsSelect
                name={inputName}
                options={getFilteredOptions(sessionKey, selectKey)}
                placeholder="Seleccione un contenedor"
                disabled={disabled}
                value={selectedContainers[sessionKey][selectKey] || ""}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  handleSelectChange(sessionKey, selectKey, e.target.value)
                }
              />
            </div>
            {!disabled && (
              <div
                onClick={() => resetSelectValue(sessionKey, selectKey)}
                aria-label="Eliminar selección"
                className="flex items-center justify-center pb-4 cursor-pointer"
              >
                <TrashCanIcon />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  return (
    <div>
      <p className="mb-6 text-lg font-semibold">Sesiones</p>
      <div className="grid grid-cols-3 gap-x-[6%]">
        {renderSession("session1", 1)}
        {renderSession("session2", 2)}
      </div>
    </div>
  );
};
